<template>
  <div v-loading.fullscreen.lock="isLoading"></div>
</template>
<script>
export default {
  data() {
    return {
      aliApi: require("@/api/wx/mall").default,
      isLoading: false,
    }
  },
  mounted() {
    console.log("route", this.$route);

    localStorage.setItem("token", "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhdWQiOiJodHRwOi8vbG9jYWxob3N0OjQwMDAiLCJpc3MiOiJodHRwOi8vbG9jYWxob3N0OjUwMDAiLCJleHAiOjE3MTc5MDE3NzMsImlhdCI6MTcxNTMwOTc3MywibmJmIjoxNzE1MzA5NzczLCJ3ZWJzaXRlIjoiUGluZHVvZHVvIiwic3ViIjoiNDM1NjYyMDUzIn0.B4_qD8IpVePJRce6hdWv5fLblX1BhkgGT3yTUGy6HwE");
    localStorage.setItem("user-info", JSON.stringify({
      mallId: 1,
      mallName: "大龙猫杂货铺",
      refreshToken: "",
      secretKey: "",
    }));
    
    this.$router.push("/");

    // if (this.$route.query.code) {
    //   this.isLoading = true;
    //   var code = this.$route.query.code;
    //   this.aliApi.codelogin(code).then(res => {
    //     this.isLoading = false;
    //     if (res.errorCode) {
    //       this.$message.error(res.errorMessage);
    //     } else {
    //       // localStorage.setItem("sys_type", res.platform);
    //       localStorage.setItem("token", res.accessToken);
    //       localStorage.setItem("user-info", JSON.stringify({
    //         // logo: res.logoUrl,
    //         // userName: res.userName,
    //         mallId: res.mallId,
    //         mallName: res.mallName,
    //         refreshToken: res.refreshToken,
    //         secretKey: res.secretKey,
    //         // expirationDate: this.$commonJs.toDateString(res.expirationDate)
    //       }));
    //       // var mall_list = [];
    //       // if (res.mallInfos) {
    //       //   res.mallInfos.forEach(x => {
    //       //     mall_list.push({ logo: x.logo, mallId: x.mallId, mallName: x.mallName, token: x.accessToken, expirationDate: this.$commonJs.toDateString(x.expirationDate)  })
    //       //   })
    //       // }
    //       // localStorage.setItem("mall_list", JSON.stringify(mall_list));

    //       this.$router.push("/");
    //     }
    //   }).catch(err => {
    //     this.isLoading = false;
    //     console.log("err", err);
    //     if (process.env.NODE_ENV != "development") {
    //       window.location.href = this.$store.state.settings.redirectUri;
    //     }
    //   })
    // } else {
    //   if (process.env.NODE_ENV != "development") {
    //     window.location.href = this.$store.state.settings.redirectUri;
    //   }
    // }
  },
  methods: {

  }
}

</script>